package com.sddamico.components.widgets

import androidx.compose.runtime.Composable
import com.sddamico.SitePalette
import com.sddamico.models.RosterMoveResponse
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.LineHeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
fun MoveCard(move: RosterMoveResponse) {
    Div(
        Modifier
            .fillMaxWidth()
            .backgroundColor(SitePalette.surface)
            .border(1.px, LineStyle.Solid, SitePalette.border)
            .borderRadius(8.px)
            .padding(1.cssRem)
            .toAttrs()
    ) {
        Column(Modifier.gap(0.375.cssRem)) {
            Row(Modifier.gap(0.5.cssRem), verticalAlignment = Alignment.CenterVertically) {
                Div(
                    Modifier
                        .backgroundColor(
                            when (move.moveType) {
                                "ADD_DROP" -> SitePalette.primary
                                "CLAIM", "WAIVER_CLAIM" -> Color.rgb(0xD97706)
                                else -> SitePalette.accent
                            }
                        )
                        .borderRadius(4.px)
                        .padding(topBottom = 0.125.cssRem, leftRight = 0.5.cssRem)
                        .display(DisplayStyle.Flex)
                        .alignItems(AlignItems.Center)
                        .toAttrs()
                ) {
                    SpanText(
                        when (move.moveType) {
                            "ADD_DROP" -> "Add/Drop"
                            "CLAIM" -> "Claim"
                            "WAIVER_CLAIM" -> "Waiver Claim"
                            else -> if (move.addedPlayerName == null) "To LIV Line" else "LIV Line Swap"
                        },
                        Modifier.fontSize(0.6875.cssRem).fontWeight(FontWeight.SemiBold).color(Colors.White)
                            .lineHeight(LineHeight.Normal)
                    )
                }
                SpanText(
                    move.clubName,
                    Modifier.fontSize(0.9375.cssRem).fontWeight(FontWeight.SemiBold).color(SitePalette.text)
                )
            }

            Row(Modifier.gap(0.375.cssRem)) {
                if (move.addedPlayerName != null) {
                    SpanText(
                        "+${move.addedPlayerName}",
                        Modifier.fontSize(0.875.cssRem).color(Color("#16a34a"))
                    )
                }
                if (move.droppedPlayerName != null) {
                    SpanText(
                        "-${move.droppedPlayerName}",
                        Modifier.fontSize(0.875.cssRem).color(Color("#dc2626"))
                    )
                }
            }

            Row(Modifier.gap(0.75.cssRem)) {
                SpanText(
                    "Effective: ${move.effectiveDate}",
                    Modifier.fontSize(0.75.cssRem).color(SitePalette.textMuted)
                )
                SpanText(
                    "By: ${move.performedBy}",
                    Modifier.fontSize(0.75.cssRem).color(SitePalette.textMuted)
                )
            }

            if (move.notes != null) {
                SpanText(
                    move.notes,
                    Modifier.fontSize(0.8125.cssRem).fontStyle(FontStyle.Italic).color(SitePalette.textSecondary)
                )
            }
        }
    }
}
